export enum PortugalIdType {
  SocialSecurityNumber = 'social_security_number',
  TaxId = 'tax_id',
  Passport = 'passport',
  IdCard = 'pt_id_card',
  ResidenceCard = 'pt_residence_card',
}
